
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import useAccountBookings from "@/composables/useAccountBookings";
import { UserType } from "@/models/enums";
import { useUserStore } from "@/store/user";
import { computed, defineComponent, onMounted, ref } from "vue";
import MyBookingItem from "./AccountMyBookingItem.vue";
import AccountSearchBookings from "./AccountSearchBookings.vue";
import { canceledBookingKey } from "@/models/symbols/CanceledBooking";
import { useEventBus } from "@vueuse/core";

export default defineComponent({
	components: {
		BaseAlert,
		BaseSection,
		BaseSpinner,
		MyBookingItem,
		AccountSearchBookings,
	},
	setup() {
		const { loading, fetchBookings, bookings, fetched } = useAccountBookings();
		const userStore = useUserStore();
		const isAgent = computed(() => userStore.getUser.type === UserType.Agent);

		onMounted(() => {
			if (!isAgent.value) {
				fetchBookings({
					status: 1,
				});
			}
		});
		
		var bookingsList = ref(bookings);
		
		const canceledBus = useEventBus(canceledBookingKey);
		
		canceledBus.on((e) => {
		
				fetchBookings({
					status: 1,
				});
				
				//bookingsList.value = bookingsList.value.filter(booking => booking.bookingReference != e.bookingReference);
		});
		return { bookingsList, loading, isAgent, fetched };
	},
});
